import * as angular from 'angular';

export class PeriodicTasksService {
    private $translate;

    constructor($translate) {
        this.$translate = $translate;
    }

    frequencyDisplay(frequency, interval) {
        let inflectionIndex = this.getInflectionIndex(interval);
        let inflections = {
            daily: [
                'periodic_tasks.frequencies.every_x_days_1',
                'periodic_tasks.frequencies.every_x_days_2',
                'periodic_tasks.frequencies.every_x_days_5',
            ],
            weekly: [
                'periodic_tasks.frequencies.every_x_weeks_1',
                'periodic_tasks.frequencies.every_x_weeks_2',
                'periodic_tasks.frequencies.every_x_weeks_5',
            ],
            monthly: [
                'periodic_tasks.frequencies.every_x_months_1',
                'periodic_tasks.frequencies.every_x_months_2',
                'periodic_tasks.frequencies.every_x_months_5',
            ],
            yearly: [
                'periodic_tasks.frequencies.every_x_years_1',
                'periodic_tasks.frequencies.every_x_years_2',
                'periodic_tasks.frequencies.every_x_years_5',
            ],
        };
        return this.$translate.instant(inflections[frequency][inflectionIndex], {
            interval: interval,
        });
    };

    reminderTimeDisplay(reminderTime) {
        let inflectionIndex = this.getInflectionIndex(reminderTime);
        let inflections = [
            'periodic_tasks.reminder.days_before_due_date_1',
            'periodic_tasks.reminder.days_before_due_date_2',
            'periodic_tasks.reminder.days_before_due_date_5',
        ];
        return this.$translate.instant(inflections[inflectionIndex], {
            reminderTime: reminderTime,
        });
    };

    getInflectionIndex(value) {
        if (value === 1) {
            // 1 dzień
            // 1 tydzień
            // 1 miesiąc
            // 1 rok
            return 0;
        } else if (12 <= value && value <= 14) {
            // 12 dni
            // 12 tygodni
            // 12 miesięcy
            // 12 lat
            return 2;
        } else if ([0, 1, 5, 6, 7, 8, 9].indexOf(value % 10) > -1) {
            // 5 dni
            // 5 tygodni
            // 5 miesięcy
            // 5 lat
            return 2;
        } else if ([2, 3, 4].indexOf(value % 10) > -1) {
            // 2 dni
            // 2 tygodnie
            // 2 miesiące
            // 2 lata
            return 1;
        }
    };

    daysOfWeekDisplay(daysOfWeek) {
        let translations = [
            ['monday', 'periodic_tasks.repeater_configurator.monday'],
            ['tuesday', 'periodic_tasks.repeater_configurator.tuesday'],
            ['wednesday', 'periodic_tasks.repeater_configurator.wednesday'],
            ['thursday', 'periodic_tasks.repeater_configurator.thursday'],
            ['friday', 'periodic_tasks.repeater_configurator.friday'],
            ['saturday', 'periodic_tasks.repeater_configurator.saturday'],
            ['sunday', 'periodic_tasks.repeater_configurator.sunday'],
        ];

        let result = [];
        translations.forEach((item) => {
            if (daysOfWeek.includes(item[0])) {
                result.push(this.$translate.instant(item[1]).toLowerCase());
            }
        });
        return result.join(', ');
    }

    monthsDisplay(months) {
        let monthsNames = [
            this.$translate.instant(
                'periodic_tasks.repeater_configurator.long_months.january'
            ),
            this.$translate.instant(
                'periodic_tasks.repeater_configurator.long_months.february'
            ),
            this.$translate.instant(
                'periodic_tasks.repeater_configurator.long_months.march'
            ),
            this.$translate.instant(
                'periodic_tasks.repeater_configurator.long_months.april'
            ),
            this.$translate.instant(
                'periodic_tasks.repeater_configurator.long_months.may'
            ),
            this.$translate.instant(
                'periodic_tasks.repeater_configurator.long_months.june'
            ),
            this.$translate.instant(
                'periodic_tasks.repeater_configurator.long_months.july'
            ),
            this.$translate.instant(
                'periodic_tasks.repeater_configurator.long_months.august'
            ),
            this.$translate.instant(
                'periodic_tasks.repeater_configurator.long_months.september'
            ),
            this.$translate.instant(
                'periodic_tasks.repeater_configurator.long_months.october'
            ),
            this.$translate.instant(
                'periodic_tasks.repeater_configurator.long_months.november'
            ),
            this.$translate.instant(
                'periodic_tasks.repeater_configurator.long_months.december'
            ),
        ];
        return months
            .map(function (month) {
                return monthsNames[month - 1].toLowerCase();
            })
            .join(', ');
    }

    daysDisplay(days) {
        return days.join(', ');
    }

    whichWhatDisplay(which, what) {
        let whichVariants = {
            pierwszy: 'pierwszą',
            drugi: 'drugą',
            trzeci: 'trzecią',
            czwarty: 'czwartą',
            piąty: 'piątą',
            ostatni: 'ostatnią',
        };
        let whatVariants = {
            środa: 'środę',
            sobota: 'sobotę',
            niedziela: 'niedzielę',
        };
        let whichTranslations = {
            first: 'periodic_tasks.repeater_configurator.first',
            second: 'periodic_tasks.repeater_configurator.second',
            third: 'periodic_tasks.repeater_configurator.third',
            fourth: 'periodic_tasks.repeater_configurator.fourth',
            fifth: 'periodic_tasks.repeater_configurator.fifth',
            last: 'periodic_tasks.repeater_configurator.last',
        };
        let whatTranslations = {
            monday: 'periodic_tasks.repeater_configurator.monday',
            tuesday: 'periodic_tasks.repeater_configurator.tuesday',
            wednesday: 'periodic_tasks.repeater_configurator.wednesday',
            thursday: 'periodic_tasks.repeater_configurator.thursday',
            friday: 'periodic_tasks.repeater_configurator.friday',
            saturday: 'periodic_tasks.repeater_configurator.saturday',
            sunday: 'periodic_tasks.repeater_configurator.sunday',
            day: 'periodic_tasks.repeater_configurator.day',
            weekday: 'periodic_tasks.repeater_configurator.weekday',
            weekend_day: 'periodic_tasks.repeater_configurator.weekend_day',
        };

        let whichTranslated = this.$translate
            .instant(whichTranslations[which])
            .toLowerCase();
        let whatTranslated = this.$translate
            .instant(whatTranslations[what])
            .toLowerCase();

        if (whatTranslated in whatVariants) {
            whatTranslated = whatVariants[whatTranslated];
            whichTranslated = whichVariants[whichTranslated];
        }

        return (whichTranslated + ' ' + whatTranslated).toLowerCase();
    }
}

angular
    .module('app')
    .service('PeriodicTasksService', PeriodicTasksService);



// WEBPACK FOOTER //
// ./node_modules/angularjs-template-loader??ref--0-1!./src/app/services/periodic_tasks.service.ts